import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { adminGetDashboardCollabsDataApi } from '../../../api/dashboard/adminGetDashboardCollabsDataApi';
import { AdminDashboardCollabsStaticsResponse, AdminDashboardDataFilter } from '../../../graphql/API';

export const useAdminGetDashboardCollabsDataQuery = (
  filter: AdminDashboardDataFilter,
): UseQueryResult<AdminDashboardCollabsStaticsResponse, Error> => {
  const adminGetDashboardCollabsData = useQuery({
    queryKey: ['admin-get-dashboard-collabs-data', filter],
    queryFn: async ({ queryKey }) => {
      const [, filter] = queryKey as [string, AdminDashboardDataFilter];
      const response = await adminGetDashboardCollabsDataApi({ ...filter });
      return response;
    },
    enabled: !!filter.fromDate || !!filter.toDate || !!filter.priorFromDate || !!filter.priorToDate,
  });
  return { ...adminGetDashboardCollabsData };
};
